<div style="position: relative">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{sectionclass}} u-color-white-900 u-bg-accent-2">
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
            <div class="o-stack__cell">
                <h5 class="u-color-white-900">{{sectiontitle}}</h5>
            </div>
        </div>
        <div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content">
            <div class="o-stack o-stack--center _u-px-small" *ngIf="quickStatsData">
                <div class="o-stack__cell content_mainCls" [ngClass]="{'no-avg-pos': isCutoffDate}" appTooltip title="Number of Ads shown to users" data-size="big" [options]="tooltipOptions">
                    <h5 class="u-color-white-900">Impressions</h5><span class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.impressions; else impressionsblock">{{quickStatsData.impressions
                        | formatNumber}}</span>
                    <ng-template #impressionsblock>
                        <span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
                    </ng-template>
                </div>

                <div class="o-stack__cell content_mainCls" [ngClass]="{'no-avg-pos': isCutoffDate}" appTooltip title="Number of times users clicked on Ads" data-size="big" [options]="tooltipOptions">
                    <h5 class="u-color-white-900">Clicks</h5>
                    <span class="u-font-medium u-lh-normal u-opacity-80p">{{quickStatsData.clicksPercentage}}%</span>
                    <div class="u-color-white-900 span_intraction" *ngIf="quickStatsData.clicks; else clicksblock" style="font-size:1.2em">{{quickStatsData.clicks
                        | formatNumber}}
                    </div>
                    <ng-template #clicksblock>
                        <div class="u-color-white-900 span_intraction" style="font-size:1.2em">--</div>
                    </ng-template>
                </div>

                <div class="o-stack__cell content_mainCls" [ngClass]="{'no-avg-pos': isCutoffDate}" appTooltip title="Number of calls" data-size="big" [options]="tooltipOptions">
                    <h5 class="u-color-white-900">Calls</h5><span class="u-font-medium u-lh-normal u-opacity-80p">{{quickStatsData.calls}}</span>
                    <ng-template #visitsblock>
                        <div class="u-color-white-900 span_intraction" style="font-size:1.2em"> --</div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="no-data-container" *ngIf="!hasData">
            <div class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{sectionclass}} u-color-white-900 u-bg-accent-2">
                <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
                    <div class="o-stack__cell">
                        <h5 class="u-color-white-900">{{sectiontitle}}</h5>
                    </div>
                </div>
                <div class="map-no-data" style="text-align:center; color:#FFF;">No Data to Display</div>
            </div>
        </div>
    </div>
</div>
